module.exports = __webpack_public_path__ + "static/media/pobal.ec99d216.jpg";